/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

/**
 * Standard error response object
 */
export type GetApiWorkspaceServiceV1WorkspacesAnalyticsWorkspaceIdErrorResponseData =
  {
    error: string;
    code?: string | undefined;
    details?: any | null | undefined;
  };

/**
 * Standard error response object
 */
export class GetApiWorkspaceServiceV1WorkspacesAnalyticsWorkspaceIdErrorResponse
  extends Error
{
  error: string;
  code?: string | undefined;
  details?: any | null | undefined;

  /** The original data that was passed to this error instance. */
  data$:
    GetApiWorkspaceServiceV1WorkspacesAnalyticsWorkspaceIdErrorResponseData;

  constructor(
    err:
      GetApiWorkspaceServiceV1WorkspacesAnalyticsWorkspaceIdErrorResponseData,
  ) {
    const message = "message" in err && typeof err.message === "string"
      ? err.message
      : `API error occurred: ${JSON.stringify(err)}`;
    super(message);
    this.data$ = err;

    this.error = err.error;
    if (err.code != null) this.code = err.code;
    if (err.details != null) this.details = err.details;

    this.name =
      "GetApiWorkspaceServiceV1WorkspacesAnalyticsWorkspaceIdErrorResponse";
  }
}

/** @internal */
export const GetApiWorkspaceServiceV1WorkspacesAnalyticsWorkspaceIdErrorResponse$inboundSchema:
  z.ZodType<
    GetApiWorkspaceServiceV1WorkspacesAnalyticsWorkspaceIdErrorResponse,
    z.ZodTypeDef,
    unknown
  > = z.object({
    error: z.string(),
    code: z.string().optional(),
    details: z.nullable(z.any()).optional(),
  })
    .transform((v) => {
      return new GetApiWorkspaceServiceV1WorkspacesAnalyticsWorkspaceIdErrorResponse(
        v,
      );
    });

/** @internal */
export type GetApiWorkspaceServiceV1WorkspacesAnalyticsWorkspaceIdErrorResponse$Outbound =
  {
    error: string;
    code?: string | undefined;
    details?: any | null | undefined;
  };

/** @internal */
export const GetApiWorkspaceServiceV1WorkspacesAnalyticsWorkspaceIdErrorResponse$outboundSchema:
  z.ZodType<
    GetApiWorkspaceServiceV1WorkspacesAnalyticsWorkspaceIdErrorResponse$Outbound,
    z.ZodTypeDef,
    GetApiWorkspaceServiceV1WorkspacesAnalyticsWorkspaceIdErrorResponse
  > = z.instanceof(
    GetApiWorkspaceServiceV1WorkspacesAnalyticsWorkspaceIdErrorResponse,
  )
    .transform(v => v.data$)
    .pipe(z.object({
      error: z.string(),
      code: z.string().optional(),
      details: z.nullable(z.any()).optional(),
    }));

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiWorkspaceServiceV1WorkspacesAnalyticsWorkspaceIdErrorResponse$ {
  /** @deprecated use `GetApiWorkspaceServiceV1WorkspacesAnalyticsWorkspaceIdErrorResponse$inboundSchema` instead. */
  export const inboundSchema =
    GetApiWorkspaceServiceV1WorkspacesAnalyticsWorkspaceIdErrorResponse$inboundSchema;
  /** @deprecated use `GetApiWorkspaceServiceV1WorkspacesAnalyticsWorkspaceIdErrorResponse$outboundSchema` instead. */
  export const outboundSchema =
    GetApiWorkspaceServiceV1WorkspacesAnalyticsWorkspaceIdErrorResponse$outboundSchema;
  /** @deprecated use `GetApiWorkspaceServiceV1WorkspacesAnalyticsWorkspaceIdErrorResponse$Outbound` instead. */
  export type Outbound =
    GetApiWorkspaceServiceV1WorkspacesAnalyticsWorkspaceIdErrorResponse$Outbound;
}
